<template>
  <popup-heading>
    <div :class="$style.container">
      <div
        v-if="showBack"
        :class="$style.back"
        @click="emit('back')"
      >
        <base-icon
          type="arrow-narrow-left-24"
        />
      </div>
      <img
        :class="$style.icon"
        alt="ai"
        :src="aiImg"
      >
      <span :class="$style.text">
        <slot />
      </span>
    </div>
  </popup-heading>
</template>

<script setup lang="ts">
import PopupHeading from '@/shared/legacy/ui/popup-layout/heading.vue';
import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';
import aiImg from './assets/ai-big.png';

const { showBack } = defineProps<{
  showBack?: boolean;
}>();

const emit = defineEmits<{
  back: [];
}>();
</script>

<style module>
.container {
  display: flex;
  align-items: center;
  height: 36px;
  width: 100%;
}
.text {
  @mixin ellipsis;
  flex: 1;
}

.icon {
  transition: .3s .3s;
  width: 36px;
  margin-right: 8px;
}

@keyframes show {
  from {
    opacity: 0;
    width: 0px;
    padding-right: 0;
    margin-right: 0;
  }
  to {
    opacity: 1;
    padding-right: 16px;
    margin-right: 16px;
    width: 40px;
  }
}

.back {
  overflow: hidden;
  cursor: pointer;
  width: 0;
  padding-right: 0;
  margin-right: 0;
  opacity: 0;
  animation: show .3s .3s forwards;
  border-right: 1px solid $borderColor;

  &+ .icon {
    width: 24px;
    margin-right: 4px;
  }
}
.back:hover {
  color: #ff533b;
}
</style>

<i18n lang="json">{}</i18n>
